import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_DOCUMENT_RENEWAL_SUCCESS,
  FETCH_DOCUMENT_RENEWAL_SUCCESS,
  GET_DOCUMENT_RENEWAL_SUCCESS,
  SAVE_DOCUMENT_RENEWAL_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchFilter, fetchRelationshipSearchSuccess, fetchStart, fetchSuccess,} from "./Common";
import {message} from "antd";


export const getResourceSuccess = ({data}) => {
  return {
    type: GET_DOCUMENT_RENEWAL_SUCCESS,
    data,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_DOCUMENT_RENEWAL_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_DOCUMENT_RENEWAL_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  // console.log(`Here > - ${data}`);
  return {
    type: FETCH_DOCUMENT_RENEWAL_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {documentType} = store.getState();
      const {query} = documentType;
      const response = await axios.get(`/document-renewal?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      // message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module, subMaster = false) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/document-renewal`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
      if(!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/document-renewal');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/document-renewal/${id}`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      history.push('/document-renewal');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/document-renewal/${id}`);
      // console.log(`Here - ${response.data}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.delete(`/document-renewal/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchAssetData = (searchValue, model, field) => {
  return async (dispatch) => {

    if(field === 'name') {
      let searchOriginalString = searchValue;
      searchOriginalString = searchOriginalString.replace(/[^a-zA-Z0-9 ]/g, '');
      searchValue = searchOriginalString;
    }

    dispatch(fetchStart());
    try {
      if(field === 'presentStatus') {
        field = 'changeStatus';
      }
      const response = await axios.get(`/common/search?searchValue=${searchValue}&model=${model}&field=${field}`);
      dispatch(fetchSuccess());
      dispatch(fetchRelationshipSearchSuccess(response.data.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
